import React from "react";
import styled from "styled-components";
import { toast } from 'react-toastify';

const DocumentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: 0.8rem;
  padding: 8px;
  border-radius: 5px;
  width: 150px;
  margin: 10px;
  position: relative;

  &:hover {
    background-color: #2fb0fa;
  }
`;

const DeleteButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: darkred;
  }
`;

const DocumentImage = styled.img`
  width: 64px;
  height: auto;
  margin-bottom: 5px;
  cursor: pointer; /* Permite que sea clickeable */
`;

const DocumentName = styled.p`
  margin: 0;
  word-break: break-word;
`;

const DocumentItem = ({ documento, onDelete }) => {
  if (!documento) return null;

  // Determinar tipo de archivo
  const isPDF = documento.nombre_documento.toLowerCase().endsWith(".pdf");
  const fileType = isPDF ? "application/pdf" : "image/jpeg"; // Soporta JPG/PNG
  const iconSrc = isPDF ? "/IMG/pdf_icon.svg" : "/IMG/jpg_icon.svg";

  const handleDownload = () => {
    try {
      let cleanBase64 = documento.documento.replace(/\s+/g, ''); // Eliminar espacios o saltos de línea innecesarios
  
      if (cleanBase64.startsWith('data:')) {
        cleanBase64 = cleanBase64.split(',')[1];
      }
  
      const byteCharacters = atob(cleanBase64);
      const byteNumbers = new Array(byteCharacters.length);
  
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
  
      const blob = new Blob([byteArray], { type: fileType });
  
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = documento.nombre_documento; // Nombre del archivo
  
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error al intentar descargar el archivo:", error);
      toast.error("Hubo un error al intentar descargar el archivo.");
    }
  };

  return (
    <DocumentContainer>
      {onDelete && (
        <DeleteButton type="button" onClick={() => onDelete(documento)}>✕</DeleteButton>
        )
      }
      

      {/* Hacer clic en el icono para descargar */}
      <DocumentImage src={iconSrc} alt="Documento Icono" onClick={handleDownload} />
      <DocumentName>{documento.nombre_documento}</DocumentName>
    </DocumentContainer>
  );
};

export default DocumentItem;
